export default __webpack_public_path__ + "static/media/recycle.9be4305d.svg";